import { render, staticRenderFns } from "./SupportHub.vue?vue&type=template&id=781089c7&scoped=true&"
import script from "./SupportHub.vue?vue&type=script&lang=js&"
export * from "./SupportHub.vue?vue&type=script&lang=js&"
import style0 from "./SupportHub.vue?vue&type=style&index=0&id=781089c7&lang=scss&scoped=true&"
import style1 from "./SupportHub.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781089c7",
  null
  
)

export default component.exports